var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "productTypeDialog",
      attrs: {
        "append-to-body": true,
        title: "",
        visible: _vm.productShow,
        width: "55%",
      },
      on: {
        "update:visible": function ($event) {
          _vm.productShow = $event
        },
      },
    },
    [
      _c("div", { staticClass: "top" }, [
        _c("h2", { staticStyle: { color: "red" } }, [
          _vm._v(_vm._s(_vm.productInfo.productNameCn)),
        ]),
        _c("span", { staticStyle: { display: "flex", "margin-top": "10px" } }, [
          _c("h3", [_vm._v(_vm._s(_vm.productInfo.bedInfo))]),
          _vm.productInfo.id
            ? _c("span", { staticStyle: { "margin-left": "20px" } }, [
                _vm._v("基础产品编号：" + _vm._s(_vm.productInfo.id)),
              ])
            : _vm._e(),
        ]),
      ]),
      _c("el-divider"),
      _c("div", { staticClass: "bottom", staticStyle: { display: "flex" } }, [
        _vm.productInfo
          ? _c(
              "div",
              { attrs: { id: "left" } },
              [_c("ProductPicture", { ref: "showPicture" })],
              1
            )
          : _vm._e(),
        _vm.productInfo.productDetail
          ? _c("div", { attrs: { id: "right" } }, [
              _vm.productInfo.productDetail.area
                ? _c("p", [
                    _vm._v("建筑面积："),
                    _c("span", [
                      _vm._v(_vm._s(_vm.productInfo.productDetail.area)),
                    ]),
                  ])
                : _vm._e(),
              _vm.productInfo.productDetail.useNumber
                ? _c("p", [
                    _vm._v("最多可住："),
                    _c("span", [
                      _vm._v(_vm._s(_vm.productInfo.productDetail.useNumber)),
                    ]),
                  ])
                : _vm._e(),
              _vm.productInfo.productDetail.floor
                ? _c("p", [
                    _vm._v("楼层："),
                    _c("span", [
                      _vm._v(_vm._s(_vm.productInfo.productDetail.floor)),
                    ]),
                  ])
                : _vm._e(),
              _vm.productInfo.bedInfo
                ? _c("p", [
                    _vm._v("床型："),
                    _c("span", [_vm._v(_vm._s(_vm.productInfo.bedInfo))]),
                  ])
                : _vm._e(),
              _vm.productInfo.productDetail.window
                ? _c("p", [
                    _vm._v("窗户："),
                    _c("span", [
                      _vm._v(_vm._s(_vm.productInfo.productDetail.window)),
                    ]),
                  ])
                : _vm._e(),
              _vm.productInfo.productDetail.isPets
                ? _c("p", [
                    _vm._v("宠物："),
                    _c("span", [
                      _vm._v(_vm._s(_vm.productInfo.productDetail.isPets)),
                    ]),
                  ])
                : _vm._e(),
              _vm.productInfo.productDetail.extraBedPolicy
                ? _c("p", [
                    _vm._v("加床："),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.productInfo.productDetail.extraBedPolicy)
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm.productInfo.productDetail.checkInInfo
                ? _c("p", [
                    _vm._v("入住时间："),
                    _c("span", [
                      _vm._v(_vm._s(_vm.productInfo.productDetail.checkInInfo)),
                    ]),
                  ])
                : _vm._e(),
              _vm.productInfo.productDetail.checkOutInfo
                ? _c("p", [
                    _vm._v("退房时间："),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.productInfo.productDetail.checkOutInfo)
                      ),
                    ]),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }